import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QuestionModule } from './question.module';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
    };

    private headers: HttpHeaders;
    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }


    getService(): Observable<QuestionModule[]> {
        return this.http.get<QuestionModule[]>(environment.apiURL + 'Main/AQQuestion/');
    }
    formData: QuestionModule = new QuestionModule();
    list: QuestionModule[];



    getServiceQuestionDashboard(QuestionId: number) {
        return this.http.get(environment.apiURL + "Main/AQQuestion/QuestionDashboard/?questionID=" + QuestionId, { responseType: 'text' });
    }

    getServiceId(id: number): Observable<QuestionModule[]> {
        return this.http.get<QuestionModule[]>(environment.apiURL + 'Main/AQQuestion/' + id);
    }



    getActive(): Observable<QuestionModule[]> {
        return this.http.get<QuestionModule[]>(environment.apiURL + 'Main/AQQuestion/Active/');
    }


    getInsertAnswer(questionID: number, answerNo: number, answerName: string, fullName: string, phoneNo: string, address: string) {

        return this.http.get(environment.apiURL + "Main/AQQuestion/InsertAnswer/?questionID=" + questionID + "&answerNo=" + answerNo + "&answerName=" + answerName + "&fullName=" + fullName + "&phoneNo=" + phoneNo + "&address=" + address, { responseType: 'text' });
    }


}
